export default __webpack_public_path__ + "static/media/directions-icon.25afa580.svg";